import { Box } from '@tf/ui';
import type React from 'react';

export const ListItemCard: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				gap: '16px',
				justifyContent: 'space-between',
				padding: '4px',
				background: '#FFF',
				border: '1px solid #DDD',
				borderRadius: '4px',
			}}
		>
			{children}
		</Box>
	);
};
